import React from 'react';
import styled from 'styled-components';

interface MaybeLinkProps {
  children: React.ReactNode;
  ctaUrl?: string;
  onClick?: () => void;
  ariaLabel?: string;
  openIn?: string;
  testId?: string;
}

export const MaybeLink: React.FC<MaybeLinkProps> = ({
  children,
  ctaUrl,
  onClick,
  ariaLabel,
  openIn = 'Same tab',
  testId,
}: MaybeLinkProps) => {
  const handleClick = () => {
    if (onClick) {
      onClick();
    }
  };

  return ctaUrl ? (
    <StyledLink
      data-testid={testId ?? 'ImageLink'}
      href={ctaUrl}
      target={openIn === 'Same tab' ? '_self' : '_blank'}
      aria-label={ariaLabel}
      onClick={handleClick}
    >
      {children}
    </StyledLink>
  ) : (
    <>{children}</>
  );
};

const StyledLink = styled.a`
  display: block;
  cursor: pointer;
`;
